"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateClient = void 0;
const internals_1 = require("@aws-amplify/api-graphql/internals");
const core_1 = require("@aws-amplify/core");
/**
 * Generates an API client that can work with models or raw GraphQL
 *
 * @returns {@link V6Client}
 * @throws {@link Error} - Throws error when client cannot be generated due to configuration issues.
 */
function generateClient(options) {
    return (0, internals_1.generateClient)({
        ...(options || {}),
        amplify: core_1.Amplify,
    });
}
exports.generateClient = generateClient;
